import { render, staticRenderFns } from "./ComplaintsFilters.vue?vue&type=template&id=76e15598&scoped=true"
import script from "./ComplaintsFilters.vue?vue&type=script&lang=js"
export * from "./ComplaintsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e15598",
  null
  
)

export default component.exports